import {GET_VENDOR_TRANSACTIONS, GET_VENDOR_TRANSACTIONS_TOTAL,GET_FILTER_TRANSACTONS_BY_DATE,} from "../actions/transactions";
const initialState = {
    all_transactions_waiting: false,
    all_transactions_success: {},
    all_transactions_error: {},
    all_transactions_waiting_total: false,
    all_transactions_success_total: {},
    all_transactions_error_total: {},
    filter_transactions_waiting : false,
    filter_transactions_success : {},
    filter_transactions_error : {},
};

export default function transactions(state = initialState, action) {
    switch (action.type) {
        case GET_VENDOR_TRANSACTIONS:
            return {
                ...state,
                all_transactions_waiting : action.all_transactions_waiting,
                all_transactions_success : action.all_transactions_response,
                all_transactions_error : action.all_transactions_error,
            };
        case GET_VENDOR_TRANSACTIONS_TOTAL : 
            return {
                ...state,
                all_transactions_waiting_total : action.all_transactions_waiting_total,
                all_transactions_success_total : action.all_transactions_response_total,
                all_transactions_error_total : action.all_transactions_error_total,

            }
        case GET_FILTER_TRANSACTONS_BY_DATE: 
            return {
                ...state,
                filter_transactions_waiting : action.filter_transactions_waiting,
                filter_transactions_success : action.filter_transactions_response, 
                filter_transactions_error : action.filter_transactions_error
            };
        default:
            return state;
    }
};